import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { ISearchState } from './search-state.store';
import {
  SEARCH_REQUEST, SEARCH_RECIEVE,
  SEARCH_REQUEST_BYKEYS,
  SEARCH_AUTOCOMPLETE,
  SEARCH_RECIEVE_LOADING,
  SEARCH_REQUEST_BYKEYS_FORCE,
  SEARCH_REQUEST_BYID
} from './search-types.store';
import { ISearchService } from '../../services';
import { SearchEntities } from '../../common/enums/search-entities.enum';
import { ActivityStatus, UserTypes } from '../../common/enums';

export const actions: ActionTree<ISearchState, IRootState> = {
  [SEARCH_REQUEST]: async ({ getters, commit, state, rootGetters }, payload?: { entity: SearchEntities }) => {

    if (rootGetters['user/userInfo'].type === undefined || rootGetters['user/userInfo'].type === UserTypes.Tenant) {
      return Promise.reject('Permission denined');
    }


    if (getters.declarants === null) {
      await (getters.service as ISearchService)!.searchEntity({ entity: SearchEntities.Declarant, $limit: 50 })
        .then(metaData => {
          commit(SEARCH_RECIEVE, { key: 'declarants', metaData });
        })
        .catch(error => console.log(error))
    }
    if (getters.contractors === null)
      await (getters.service as ISearchService)!.searchEntity({ entity: SearchEntities.Contractor })
        .then(metaData => {
          commit(SEARCH_RECIEVE, { key: 'contractors', metaData });
        })
        .catch(error => console.log(error))
  }
  , [SEARCH_REQUEST_BYKEYS]: ({ state, getters, commit, rootGetters }, keys: string[]) => {

    if (rootGetters['user/userInfo'].type === undefined || rootGetters['user/userInfo'].type === UserTypes.Tenant) {
      return Promise.reject('Permission denined');
    }
    return new Promise(
      (resolve, reject) => keys.forEach(async (key: string, index: number) => {
        if (state[`${key}s`] !== null) {
          resolve(state[`${key}s`])
        }
        else {
          if (getters.status[`${key}s`] === ActivityStatus.Loading) return;
          commit(SEARCH_RECIEVE_LOADING, { key: `${key}s`, activityStatus: ActivityStatus.Loading })
          await (state.service as ISearchService)!.searchEntity({ entity: key, $limit: 50 })
            .then(metaData => {
              commit(SEARCH_RECIEVE, { key: `${key}s`, metaData: metaData || [] });
              resolve(metaData)
            })
            .catch(error => {
              commit(SEARCH_RECIEVE_LOADING, { key: `${key}s`, activityStatus: ActivityStatus.LoadFailed })
              reject(error)
            })
        }
      })
    )
  }
  , [SEARCH_REQUEST_BYKEYS_FORCE]: async ({ state, getters, commit, rootGetters }, payload: { keys: string[], force?: boolean }) => {

    if (rootGetters['user/userInfo'].type === undefined || rootGetters['user/userInfo'].type === UserTypes.Tenant) {
      return Promise.reject('Permission denined');
    }
    return new Promise(
      (resolve, reject) => payload.keys.forEach(async (key: string, index: number) => {
        if (getters.status[`${key}s`] === ActivityStatus.Loading) return;
        commit(SEARCH_RECIEVE_LOADING, { key: `${key}s`, activityStatus: ActivityStatus.Loading })
        await (state.service as ISearchService)!.searchEntity({ entity: key })
          .then(metaData => {
            commit(SEARCH_RECIEVE, { key: `${key}s`, metaData: metaData || [] });
            resolve(metaData)
          })
          .catch(error => {
            commit(SEARCH_RECIEVE_LOADING, { key: `${key}s`, activityStatus: ActivityStatus.LoadFailed })
            reject(error)
          })
      })
    )
  }
  , [SEARCH_AUTOCOMPLETE]: async ({ getters, state, commit },
                                  payload: { entity?: SearchEntities | SearchEntities[],
                                    query?: string, limit?: number, apartment?: number[],
                                    block?: number[], problem: number, role?: number[] }) => {
    return await (getters.service as ISearchService)!.searchEntity({
      entity: payload.entity,
      q: payload.query,
      $limit: payload.limit,
      apartment: payload.apartment,
      block: payload.block,
      problem: payload.problem,
      role: payload.role
    })
      .then(metaData => {
        return Promise.resolve(metaData)
      })
      .catch(error => console.log(error))
  }
  , [SEARCH_REQUEST_BYID]: ({getters}, entityId: number) => {
    const service: ISearchService= getters.service;

    return service.searchEntityById(entityId)
         .then( entity =>  Promise.resolve(entity))
         .catch(err=> Promise.reject(err))
  }
}



// WEBPACK FOOTER //
// ./src/store/search/search-actions.store.ts